<template>
    <form class="tw-space-y-5" data-test-id="user-language-form" @submit.prevent="onSubmit">
        <div>
            <l-select
                id="language"
                :label="$t('profile.edit.language')"
                :value.sync="form.lang"
                :disabled="hasAllFieldsDisabled"
                :options="languageSelectOptions"
                class="tw"
            />
            <p class="tw-mt-2 tw-text-sm tw-text-gray-400">
                {{ $t("profile.edit.languageHelpText") }}
            </p>
        </div>

        <l-text-alert
            v-if="hasError"
            class="tw-leading-none tw-text-sm"
            type="danger"
            data-test-id="error"
            :text="errorMessage"
        />

        <l-base-button type="submit" :button-types="['default', 'raised']" :disabled="isLoading">
            {{ $t("profile.edit.btnUpdateLanguage") }}
        </l-base-button>
    </form>
</template>

<script>
import { mapGetters } from "vuex";
import languages from "@/config/languages";

import LTextAlert from "@/components/LTextAlert";
import LSelect from "@/components/LSelect";
import LBaseButton from "@/components/LBaseButton";

export default {
    components: { LTextAlert, LSelect, LBaseButton },
    data() {
        return {
            hasError: false,
            errorMessage: "",
            isLoading: false,
            form: {
                lang: "",
            },
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
        }),
        languageSelectOptions() {
            return languages.map(lang => ({
                value: lang.code,
                text: `${lang.name} ${
                    lang.isPlatformLanguage ? `(${this.$t(`language.isPlatformLanguage`)})` : ""
                }`,
            }));
        },
        hasAllFieldsDisabled() {
            return this.isLoading;
        },
    },
    created() {
        this.prefillForm();
    },
    methods: {
        prefillForm() {
            Object.assign(this.form, {
                lang: this.currentUser.lang ?? "",
            });
        },
        async onSubmit() {
            this.isLoading = true;
            this.hasError = false;

            try {
                await this.$store.dispatch("users/current/updateProfile", {
                    payload: {
                        scope: ["language"],
                        form: this.form,
                    },
                });

                // reload current path so that _all_ translations (including backend ones are up-to-date)
                this.$router.go();
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.response?.data?.message ?? err.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
